export default __webpack_public_path__ + "static/media/AcessosIconEdit.2f803930.svg";